export default __webpack_public_path__ + "static/feature-banner-onlineshopping-727d20c336df602c6dc0591ff1b51176.jpg";